import { ContentRoute, LayoutSplashScreen } from "../_metronic/layout";
import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router";

// import Calcumate from "./pages/Calcumate";
import CalendarPage from "./modules/Calendar/CalendarPage";
import { ContactDetails } from "./modules/ContactDeals/page/ContactDetails";
import { ContactPage } from "./modules/ContactDeals/page/ContactPage";
import { CustomerPage } from "./modules/Customer/CustomerPage";
import { CustomersDetails } from "./modules/Customer/page/CustomersDetails";
import { DashboardPage } from "./pages/DashboardPage";
import { Deals } from "./modules/ContactDeals/page/Deals";
import { DealsPage } from "./modules/ContactDeals/page/DealsPage";

import { OrderPage } from "./modules/Order/OrderPage";
import { OrdersDetails } from "./modules/Order/OrdersDetailsPage";
import { ReportingListPage } from "./modules/Reporting/ReportingListPage";
import { ReportingPage } from "./modules/Reporting/ReportingPage";
import { Settings } from "./pages/Settings";
import { TasksPage } from "./modules/Tasks/TasksPage";
import { QuotesPage } from "./modules/Quotes/QuotesPage";
import { KycListPage } from "./modules/KycList/KycListPage";
import SettingList from "./modules/Settings/pages/SettingPages";
import TermsAndCondition from "./pages/TermsAndCondition";
import AddendumOrder from "./pages/AddendumOrder";
import AppSigninAsCustomer from "./pages/AppSigninAsCustomer";
import { SuccessfulOrder } from "./modules/Order/components/SuccessfulOrder";
import { OrderEditPage } from "./modules/Order/OrderEditPage";
import { InvoicePage } from "./modules/Invoice/InvoicePage";
import { CreditPage } from "./modules/Invoice/CreditPage";
import { OrdersDetailStripe } from "./modules/Order/order-stripe/OrderDetailStripePage";
import PaymentPage from "./modules/demoPage";
import { NewOrderStripe } from "./modules/Order/NewOrderStripe/NewOrderStripePage";
import { EditOrderStripe } from "./modules/Order/EditOrderStripe";
import { EditOrderStripeRelease } from "./modules/Order/EditOrderStripeRelease";
import { InvoiceReportPage } from "./modules/Invoice/InvoiceReportPage";

// const SettingList = lazy(() => import("./modules/Settings/pages/SettingPages"));

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Routes>
        {/* Redirect from root URL to /orders. */}
        <Route path="" element={<Navigate to="/orders" replace />} />

        {ContentRoute({ path: "dashboard", component: DashboardPage })}
        {ContentRoute({ path: "setting-page", component: Settings })}
        {ContentRoute({ path: "terms-and-condition", component: TermsAndCondition })}
        {ContentRoute({ path: "addendum-order", component: AddendumOrder })}
        {ContentRoute({ path: "app-signin/:orderId", component: AppSigninAsCustomer })}

        {/* SettingList contains a nested router, so we need /settings/* */}
        {ContentRoute({ path: "settings/*", component: SettingList })}

        {ContentRoute({ path: "deals", component: DealsPage })}
        {ContentRoute({ path: "online-quotes", component: QuotesPage })}
        {ContentRoute({ path: "kyc-list", component: KycListPage })}

        {ContentRoute({ path: "deal-view/:id", component: Deals })}

        {ContentRoute({ path: "contacts", component: ContactPage })}
        {ContentRoute({ path: "invoices", component: InvoicePage })}
        {ContentRoute({ path: "sub", component: CreditPage })}
        {ContentRoute({ path: "invoice-report", component: InvoiceReportPage })}

        {ContentRoute({ path: "contact-details/:id", component: ContactDetails })}

        {/* {ContentRoute({ path: "new-order", component: NewOrder })} */}
        {ContentRoute({ path: "new-order-stripe", component: NewOrderStripe })}
        {ContentRoute({ path: "successful-order/:id", component: SuccessfulOrder })}
        {ContentRoute({ path: "customers", component: CustomerPage })}
        {ContentRoute({ path: "customer-details/:id", component: CustomersDetails })}
        {ContentRoute({ path: "orders", component: OrderPage })}
        {ContentRoute({ path: "create-return", component: OrderPage })}
        {ContentRoute({ path: "create-access", component: OrderPage })}

        {ContentRoute({ path: "reporting", component: ReportingPage })}
        {ContentRoute({ path: "reporting/:id", component: ReportingListPage })}
        {ContentRoute({ path: "calendar", component: CalendarPage })}
        {ContentRoute({ path: "order-details/:id", component: OrdersDetails })}
        {ContentRoute({ path: "order-details-stripe/:id", component: OrdersDetailStripe })}
        {/* {ContentRoute({ path: "edit-order/:id", component: OrderEditPage })} */}
        {ContentRoute({ path: "edit-order/:id", component: EditOrderStripe })}
        {ContentRoute({ path: "edit-order-release/:id", component: EditOrderStripeRelease })}

        {ContentRoute({ path: "tasks", component: TasksPage })}
        {ContentRoute({ path: "stripe", component: PaymentPage })}

        <Route path="*" element={<Navigate to="/error/error-v1" replace />} />
      </Routes>
    </Suspense>
  );
}
